'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  padding-top: ', ';\n  padding-bottom: ', ';\n  margin-bottom: 0;\n  text-align: center;\n  color: ', ';\n  ', ';\n'], ['\n  background-color: ', ';\n  padding-top: ', ';\n  padding-bottom: ', ';\n  margin-bottom: 0;\n  text-align: center;\n  color: ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    background-color: transparent;\n    padding: 0;\n    margin-bottom: ', ';\n  '], ['\n    background-color: transparent;\n    padding: 0;\n    margin-bottom: ', ';\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.p(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.color.gray;
}, (0, _polished.rem)(15), (0, _polished.rem)(15), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.copryrightTextColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.media.s(_templateObject2, (0, _polished.rem)(15));
});

var Copyright = function Copyright(props) {
  var children = props.children,
      className = props.className;

  return _react2.default.createElement(
    Wrapper,
    { className: className },
    children
  );
};

Copyright.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

Copyright.defaultProps = {
  className: ''
};

exports.default = Copyright;
Copyright.__docgenInfo = [{
  'description': '',
  'displayName': 'Copyright',
  'methods': [],
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'children': {
      'type': {
        'name': 'node'
      },
      'required': true,
      'description': ''
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Copyright/Copyright.js'] = {
    name: 'Copyright',
    docgenInfo: Copyright.__docgenInfo,
    path: 'src/Copyright/Copyright.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Copyright/Copyright.js
// module id = 296
// module chunks = 1